'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';

/**
 * Workspace "retry book": re-run the whole pipeline (analysis → portraits →
 * cover → pages) on a FAILED illustration. The executor reserves analysis again
 * (mandatory), resets the shell and starts a fresh standalone run.
 */
export async function retryIllustrationGeneration(input: {
  bookId: string;
}): Promise<ActionResult<{ ok: true }>> {
  try {
    const familyId = await SessionService.getFamilyId();
    const userId = await SessionService.getUserId();
    if (!familyId || !userId) return { success: false, error: 'Not authenticated' };

    const { getContentPlanExecutor } = await import('@/contexts/content/services/ContentPlanExecutor');
    await getContentPlanExecutor().restartBookGeneration(input.bookId, familyId);
    return { success: true, data: { ok: true } };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('retryIllustrationGeneration', e) };
  }
}
